// Servicio para manejar interacciones con Supabase.
// Centraliza llamadas a la base de datos para obtener visitas e interacciones del usuario.

import { supabase } from '../lib/supabase';

// Reinicia los contadores de interacciones del usuario.
// Parámetros: userId (ID del usuario), queryClient (opcional) para invalidar queries.
// Actualiza las columnas visitas y me_gustas a 0 en la tabla interaction_counter.
// Retorna: true si fue exitoso, false en caso de error.
export const getMyVisits = async (userId, queryClient = null) => {
  try {
    const { error } = await supabase
      .from('interaction_counter')
      .update({ 
        visitas: 0, 
        me_gustas: 0 
      })
      .eq('user_id', userId);

    if (error) {
      console.error('Error al reiniciar contadores de interacción:', error);
      return false;
    }

    // Invalidar queries para que los componentes se actualicen inmediatamente
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['visitCount'] });
      queryClient.invalidateQueries({ queryKey: ['interactionCounter'] });
      queryClient.invalidateQueries({ queryKey: ['tabeador_count'] });
      console.log('[getMyVisits] Contadores reiniciados y queries invalidadas para usuario:', userId);
    } else {
      console.log('[getMyVisits] Contadores reiniciados para usuario:', userId, '(sin queryClient para invalidación)');
    }
    
    return true;
  } catch (err) {
    console.error('Excepción al reiniciar contadores de interacción:', err);
    return false;
  }
};

// Obtiene la lista de interacciones del usuario.
// No requiere parámetros, usa la sesión actual.
// Retorna: array de interacciones o null en caso de error.
export const getMyInteractionsList = async () => {
  try {
    const { data, error } = await supabase.rpc('get_my_interaction_list_alt');
    if (error) {
      console.error('Error en getMyInteractionsList:', error);
      return null;
    }
    return data;
  } catch (err) {
    console.error('Excepción en getMyInteractionsList:', err);
    return null;
  }
};
